import React from "react";
import {
  ShieldCheck,
  Truck,
  BadgeCheck,
  Users,
} from "lucide-react";

const WhyChooseSection = () => {
  const data = [
    {
      icon: <ShieldCheck size={34} />,
      title: "Trusted & Transparent",
      desc: "We maintain complete transparency in all business transactions with proper GST compliance and verified processes.",
    },
    {
      icon: <Truck size={34} />,
      title: "Fast & Reliable Supply",
      desc: "Timely delivery with a strong industrial supply network ensures your operations never get delayed.",
    },
    {
      icon: <BadgeCheck size={34} />,
      title: "Quality Assurance",
      desc: "We provide only high-quality and tested materials that meet industrial standards and customer expectations.",
    },
    {
      icon: <Users size={34} />,
      title: "Strong Business Relationship",
      desc: "We believe in long-term partnerships built on trust, support, and consistent service quality.",
    },
  ];

  return (
    <section className="why-section">

      {/* HEADING */}
      <div className="heading">
        <h1>WHY CHOOSE JAINA ENTERPRISES</h1>
        <div className="line"></div>
      </div>

      {/* CARDS */}
      <div className="grid">
        {data.map((item, index) => (
          <div className="card" key={index}>
            
            {/* TOP ICON */}
            <div className="icon-box">
              {item.icon}
            </div>

            <h2>{item.title}</h2>
            <p>{item.desc}</p>

          </div>
        ))}
      </div>

    <style>{`
.why-section{
  width:100%;
  padding:80px 20px;
  background:linear-gradient(135deg,#f8fafc,#eef4ff);
  overflow:hidden;
}

/* ==========================
   HEADING
========================== */

.heading{
  text-align:center;
  margin-bottom:55px;
}

.heading h1{
  font-size:42px;
  font-weight:900;
  color:#0A2E73;
  letter-spacing:2px;
  margin:0;
  line-height:1.3;
}

.line{
  width:120px;
  height:4px;
  background:#d4af37;
  margin:14px auto 0;
  border-radius:50px;
  transition:.4s ease;
}

.heading:hover .line{
  width:260px;
  box-shadow:0 5px 15px rgba(212,175,55,.4);
}

/* ==========================
   GRID
========================== */

.grid{
  max-width:1200px;
  margin:auto;
  display:grid;
  grid-template-columns:repeat(4,1fr);
  gap:25px;
}

/* ==========================
   CARD
========================== */

.card{
  background:#fff;
  padding:30px 22px;
  border-radius:18px;
  text-align:center;
  box-shadow:0 10px 30px rgba(0,0,0,.08);
  transition:.4s ease;
  position:relative;
  overflow:hidden;
  cursor:pointer;
}

.card::before{
  content:"";
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:5px;
  background:linear-gradient(90deg,#d4af37,#0A2E73);
  transform:scaleX(0);
  transform-origin:left;
  transition:.4s;
}

.card:hover::before{
  transform:scaleX(1);
}

.card:hover{
  transform:translateY(-10px);
  box-shadow:0 20px 50px rgba(0,0,0,.15);
}

/* ==========================
   ICON
========================== */

.icon-box{
  width:70px;
  height:70px;
  margin:auto;
  display:flex;
  align-items:center;
  justify-content:center;
  background:rgba(10,46,115,.08);
  border-radius:50%;
  color:#0A2E73;
  margin-bottom:18px;
  transition:.35s;
}

.card:hover .icon-box{
  background:#0A2E73;
  color:#fff;
  transform:rotate(10deg) scale(1.08);
}

/* ==========================
   TEXT
========================== */

.card h2{
  font-size:20px;
  font-weight:800;
  color:#0A2E73;
  margin-bottom:12px;
  line-height:1.4;
}

.card p{
  font-size:15px;
  color:#555;
  line-height:1.8;
  margin:0;
}

/* ==========================
   TABLET
========================== */

@media (max-width:992px){

  .why-section{
    padding:70px 20px;
  }

  .heading h1{
    font-size:36px;
  }

  .grid{
    grid-template-columns:repeat(2,1fr);
    gap:22px;
  }

  .card{
    padding:28px 20px;
  }

}

/* ==========================
   MOBILE
========================== */

@media (max-width:768px){

  .why-section{
    padding:55px 15px;
  }

  .heading{
    margin-bottom:35px;
  }

  .heading h1{
    font-size:30px;
    letter-spacing:1px;
  }

  .line{
    width:80px;
  }

  .heading:hover .line{
    width:140px;
  }

  .grid{
    grid-template-columns:1fr;
    gap:20px;
  }

  .card{
    padding:25px 18px;
    border-radius:16px;
  }

  .icon-box{
    width:60px;
    height:60px;
  }

  .card h2{
    font-size:18px;
  }

  .card p{
    font-size:14px;
    line-height:1.7;
  }

}

/* ==========================
   SMALL MOBILE
========================== */

@media (max-width:480px){

  .why-section{
    padding:45px 12px;
  }

  .heading h1{
    font-size:26px;
  }

  .line{
    width:70px;
  }

  .card{
    padding:22px 16px;
  }

  .icon-box{
    width:55px;
    height:55px;
  }

  .card h2{
    font-size:17px;
  }

  .card p{
    font-size:13px;
    line-height:1.6;
  }

}
`}</style>

    </section>
  );
};

export default WhyChooseSection;